@if (!isLinear) {
    @if (!isEpcotEnabled) {
        <i class="theme-warning warning-color"></i>
    }
    @if (isEpcotEnabled) {
        <i class="theme-warning warning-color"></i>
    }
} @else {
    <i class="theme-warning"></i>
}
